import { DeleteWithToken, GetWithToken, PostWithToken, PatchWithToken } from "../../lib/request";

export const createNewSlide = (data) => {
    return async function (dispatch) {
        const result = await PostWithToken('/v2/admin/slides', data);
        return result;
    }
}

export const getAllSlides = (query) => {
    return async function (dispatch) {
        const limit = query?.limit || 10;
        const offset = query?.offset || 0;
        const result = await GetWithToken(`/v2/admin/slides?limit=${limit}&offset=${offset}`);
        return result;
    }
}

export const getSlideById = (id) => {
    return async function (dispatch) {
        const result = await GetWithToken(`/v2/admin/slides/${id}`);
        return result;
    }
}

export const updateSlideById = (id, data) => {
    return async function (dispatch) {
        const result = await PatchWithToken(`/v2/admin/slides/${id}`, data);
        return result;
    }
}

export const deleteSlideById = (id) => {
    return async function (dispatch) {
        const result = await DeleteWithToken(`/v2/admin/slides/${id}`);
        return result;
    }
}
